import logo from './logo.png';
import './App.css';

function App() {
  return (
    <>
      <br />
      <div className="card">
        <div className="content">
          <div className="title-holder">
            <img src={logo} className="logo" height={150} alt="logo" />
            <h1>Get ready for the change.</h1>
            <p>Website coming soon. Please check back to know more.</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
